import React from 'react';
import './customer-dashboard.scss';
import {
  Chart,
  Series,
  ArgumentAxis,
  CommonSeriesSettings,
  CommonAxisSettings,
  Grid,
  Export,
  Legend,
  Margin,
  Tooltip,
  Label,
  Format,
} from 'devextreme-react/chart';

import { architectureSources, sharingStatisticsInfo, seriesTypeLabel } from './customer-count-data.js';
import { populationData } from './custoler-sales-data';

const CustomerCount = () => {

  return (
    <React.Fragment>
      <Chart
        palette="Violet"
        dataSource={sharingStatisticsInfo}
        title="TalentWave Kullanıcı Sayıları"
      >
        <CommonSeriesSettings
          argumentField="month"
          type={"line"}
        />
        <CommonAxisSettings>
          <Grid visible={true} />
        </CommonAxisSettings>
        {
          architectureSources.map((item) => <Series
            key={item.value}
            valueField={item.value}
            name={item.name} />)
        }
        <Margin bottom={20} />
        <ArgumentAxis
          allowDecimals={false}
          axisDivisionFactor={60}
        >
          <Label>
            <Format type="decimal" />
          </Label>
        </ArgumentAxis>
        <Legend
          verticalAlignment="top"
          horizontalAlignment="right"
        />
        <Export enabled={true} />
        <Tooltip enabled={true} />
      </Chart>
      
    </React.Fragment>
  )
}

const Sales = () =>{
  return(
    <React.Fragment>
      <Chart
        title="Satış Rakamları"
        dataSource={populationData}
        id="chart"
      >

        <ArgumentAxis tickInterval={10}>
          <Label format="decimal" />
        </ArgumentAxis>

        <Series
          type="bar"
        />

        <Legend
          visible={false}
        />

      </Chart>
    </React.Fragment>
  )
}

export default () => (
  <React.Fragment>
    <h2 className={'content-block'}>Customer Dashboard</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <CustomerCount/>
        <Sales/>
      </div>
    </div>
  </React.Fragment>
);
